import { render, staticRenderFns } from "./FormFieldSlider.vue?vue&type=template&id=6d8bfea0&scoped=true"
import script from "./FormFieldSlider.vue?vue&type=script&lang=js"
export * from "./FormFieldSlider.vue?vue&type=script&lang=js"
import style0 from "./FormFieldSlider.vue?vue&type=style&index=0&id=6d8bfea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8bfea0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BasicImage: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/basic/BasicImage.vue').default})
